import { useMemo } from "react";

function InputCounterRenderer({
  value = "",
  maxLength = 0,
  label = "character",
  labelSuffix = ""
}: Pick<TInputCounterProps, "label" | "labelSuffix" | "maxLength" | "value">) {
  const state = useMemo(() => {
    const curr = typeof value === "string" ? value.length : 0;
    const max = maxLength > 0 ? maxLength : 0;

    return {
      curr,
      max,
      label: curr > 1 ? label + "s" : label
    };
  }, [value, maxLength, label]);

  return <>
    {state.curr} / {state.max} {state.label} {labelSuffix}
  </>;
}

type TInputCounterProps = {
  show?: boolean;
  className?: string;
  /** singluar label, will be automatically inject "s" when current length > 1 */
  label?: string;
  labelSuffix?: string;
  value?: string|number|readonly string[];
  maxLength?: number;
  staticMode?: boolean;
};

export function InputCounter({
  show = true,
  value = "",
  maxLength = 0,
  label = "character",
  labelSuffix = "",
  className = "",
  staticMode = false
}: TInputCounterProps) {
  return <>
    {show && (typeof maxLength === "number" && maxLength > 0) && <>
      <div className={`input-counter ${className}`.trim()} data-comp="InputCounter">
        <span>
          {!staticMode && <InputCounterRenderer value={value} maxLength={maxLength}
            label={label}
            labelSuffix={labelSuffix}
          />}

          {staticMode && <>Maximum character(s): {maxLength}</>}
        </span>
      </div>
    </>}
  </>;
}
